import { render, staticRenderFns } from "./formScreenPaymentSelector.vue?vue&type=template&id=2a2435fe&scoped=true"
import script from "./formScreenPaymentSelector.vue?vue&type=script&lang=js"
export * from "./formScreenPaymentSelector.vue?vue&type=script&lang=js"
import style0 from "./formScreenPaymentSelector.vue?vue&type=style&index=0&id=2a2435fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2435fe",
  null
  
)

export default component.exports